import React from 'react';

import GridComponent from './GridComponent';

export default ({ children, ...props }) => (
  <GridComponent primaryClassName="Grid-row" {...props}>
    {children}
  </GridComponent>
);



// WEBPACK FOOTER //
// ./src/components/basic/grid/GridRow.js